export const createTestConvolverNodeBufferReassignabilitySupport = (createNativeAudioNode) => {
    return (nativeContext) => {
        const nativeConvolverNode = createNativeAudioNode(nativeContext, (ntvCntxt) => ntvCntxt.createConvolver());
        nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
        try {
            nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
        }
        catch (_a) {
            return false;
        }
        return true;
    };
};
//# sourceMappingURL=/build/es2018/factories/test-convolver-node-buffer-reassignability-support.js.map